import { createStore } from 'satcheljs';
import { ObservableMap } from 'owa-mobx4-adapter';
// Register mutators
import '../mutators/folderPrefetchedMutator';
var defaultStore = {
    frequentlyUsedFolders: [],
    isInitialized: false,
    prefetchedFolderIds: new ObservableMap({}),
};
export var getStore = createStore('frequentlyUsedFoldersStore', defaultStore);
var store = getStore();
export default store;
//# sourceMappingURL=store.js.map